import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";

const MonthlySegmentPogressBarInfo = ({
  project,
  auth,
  currentMonthlySegment
}) => {
  const budgetConsumed = project.rate * currentMonthlySegment.consumed;
  const segmentBudget = project.rate * currentMonthlySegment.budgetHours;

  return (
    <React.Fragment>
      <span
        id="segment-info"
        data-tooltip-content={`$${budgetConsumed.toLocaleString(undefined, {
          maximumFractionDigits: 2
        })} / $${segmentBudget.toLocaleString(undefined, {
          maximumFractionDigits: 2
        })}`}
        data-tooltip-variant={auth.isNightMode ? "dark" : "light"}
        data-html
        data-for="segment-info"
        style={{ fontSize: 12 }}
      >
        {currentMonthlySegment.consumed} / {currentMonthlySegment.budgetHours}
        <small> HRS</small>
      </span>
      <ReactTooltip
        anchorId="segment-info"
        className={`custom-tooltip ${auth.isNightMode ? "dark" : "light"}`}
        place="left"
        type={auth.isNightMode ? "dark" : "light"}
        effect="solid"
        globalEventOff="click"
      />
    </React.Fragment>
  );
};

MonthlySegmentPogressBarInfo.propTypes = {
  project: PropTypes.object,
  auth: PropTypes.object,
  currentMonthlySegment: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    auth: state.reducers.auth
  };
}

export default withRouter(
  connect(mapStatesToProps, null)(MonthlySegmentPogressBarInfo)
);
